function getAddressComponent(addressComponents = [], type) {
	return addressComponents.find((component) => component.types?.includes(type));
}

function getAddressComponentValue(addressComponents, type, nameType = 'long_name') {
	return getAddressComponent(addressComponents, type)?.[nameType] || '';
}

function getCityValue(addressComponents) {
	const cityTypes = [
		'locality',
		'postal_town',
		'sublocality',
		'sublocality_level_1',
		'administrative_area_level_2',
	];

	for (const type of cityTypes) {
		const value = getAddressComponentValue(addressComponents, type);
		if (value) {
			return value;
		}
	}

	return '';
}

export function parseGooglePlaceAddress(place) {
	const addressComponents = place?.address_components || [];
	const streetNumber = getAddressComponentValue(addressComponents, 'street_number');
	const route = getAddressComponentValue(addressComponents, 'route');
	const subpremise = getAddressComponentValue(addressComponents, 'subpremise');
	const premise = getAddressComponentValue(addressComponents, 'premise');

	const streetAddress = [streetNumber, route].filter(Boolean).join(' ').trim();
	const unitValue = subpremise || premise;
	const addressLine = [streetAddress, unitValue].filter(Boolean).join(' ').trim();

	const postalCode = [
		getAddressComponentValue(addressComponents, 'postal_code'),
		getAddressComponentValue(addressComponents, 'postal_code_suffix'),
	]
		.filter(Boolean)
		.join('-');

	return {
		address:
			addressLine ||
			place?.name ||
			place?.formatted_address?.split(',')?.[0]?.trim() ||
			'',
		city: getCityValue(addressComponents),
		state: getAddressComponentValue(
			addressComponents,
			'administrative_area_level_1',
			'short_name'
		),
		postalCode,
		formattedAddress: place?.formatted_address || '',
		placeId: place?.place_id || '',
		latitude: place?.geometry?.location?.lat?.() ?? null,
		longitude: place?.geometry?.location?.lng?.() ?? null,
	};
}

export function normalizeClientAddress(client) {
	const addressObject =
		client?.address && typeof client.address === 'object' ? client.address : null;

	return {
		address: addressObject?.address || client?.address || '',
		city: addressObject?.city || client?.city || '',
		state: addressObject?.state || client?.state || '',
		postalCode: addressObject?.postalCode || client?.postalCode || '',
	};
}
